<script>
  import NodeTypeEditor from './NodeTypeEditor.svelte';
  import NodeSelectorEditor from './NodeSelectorEditor.svelte';
  import NodeCustomPropertiesEditor from './NodeCustomPropertiesEditor.svelte';
  
  export let question;
  export let updateWorkingQuestion;
  
  // Check if this question creates nodes - reactive derived state
  $: hasNodesHandler = question.dataset?.some(handler => handler[0] === 'nodes');
  $: hasSelfHandler = question.dataset?.some(handler => handler[0] === 'setSelf');
  $: hasSelfPropsHandler = question.dataset?.some(handler => handler[0] === 'selfProps');
  $: isNodeCreator = hasNodesHandler || hasSelfHandler;
</script>

{#if isNodeCreator}
  <div class="node-editor-section">
    <h5>
      Node Configuration
      {#if hasSelfHandler}
        <span class="node-type-badge self">SELF NODE</span>
      {:else if hasNodesHandler}
        <span class="node-type-badge regular">REGULAR NODES</span>
      {/if}
    </h5>
    
    <NodeTypeEditor 
      {question}
      {updateWorkingQuestion}
    />
    
    <!-- Only show selector editor for regular nodes, not self nodes -->
    {#if hasNodesHandler}
      <NodeSelectorEditor 
        {question}
        {updateWorkingQuestion}
      />
    {/if}
    
    <NodeCustomPropertiesEditor 
      {question}
      {updateWorkingQuestion}
    />
  </div>
{/if}

<style lang="scss">
  .node-editor-section {
    border: 2px solid #e5e7eb;
    border-radius: 8px;
    padding: 15px;
    margin-bottom: 20px;
    background: rgba(255, 255, 255, 0.7);
    
    h5 {
      margin-bottom: 15px;
      font-weight: bold;
      font-size: 0.85rem;
      color: #374151;
      display: flex;
      align-items: center;
      gap: 8px;
    }
  }
  
  .node-type-badge {
    padding: 2px 8px;
    border-radius: 12px;
    font-size: 10px;
    font-weight: bold;
    letter-spacing: 0.5px;
    
    &.self {
      background: #059669;
      color: white;
    }
    
    &.regular {
      background: #3b82f6;
      color: white;
    }
  }
</style>